<script>
  import HazardControls from './HazardControls.svelte';
  import {sgettext} from '../../i18n.js';
  export let hazard = {};

</script>

<style>
  .hazard-detail {
    display: flex;
  }

  .hazard-detail {
    flex: 1;
    border: 1px solid #dee2e6;
  }

  .hazard-name {
    font-weight: bold;
  }

  .hazard-icon-container {
    width: 350px;
    border: 1px solid lightgrey;
    background-color: white;
  }

  .hazard-icon {
    width: 200px;
  }

  .control-icon {
    width: 50px;
  }

  .icon {
    font-size: 10px;
    width: 64px;
    margin-right: 30px;
    padding: 15px;
  }

  .icon img {width: 100%;}

  .other-info {
    color: #858585;
    font-size: 14px;
  }
</style>


<div class="d-flex">
  <div class="d-flex flex-column p-3">
    <h5>{sgettext('$$RISK$$')}</h5>
    <div class="hazard-icon-container d-flex flex-column p-3">
      <div class="d-flex justify-content-center">
        {#if hazard.icon}
          <img src={hazard.icon.icon.url} alt={hazard.icon.name} class="hazard-icon"/>
        {/if}
      </div>

      <div class="mt-3 text-center">
        <div class="hazard-name">{hazard.name}</div>
        <div class="other-info mb-3">{@html hazard.description}</div>
      </div>
    </div>
    <div class="mt-3 text-center text-secondary">
      <div><strong>{sgettext('$$ENERGY$$')}</strong>: {hazard.energy.name}</div>
      <div><strong>{sgettext('$$MECHANISM$$')}</strong>: {hazard.mechanism.name}</div>
    </div>

  </div>
  <div class="p-3">
    <h5>{sgettext('$$CONTROLS$$')}</h5>
    {#each hazard.controls as control}
      <div class="d-flex">
        <div class="p-1">
          <img src={control.icon.url} alt={control.icon.name} class="control-icon"/>
        </div>
        <div class="p-1">
          <p class="text-bold" class:text-danger={control.expired} >
            <i class="fa fa-exclamation-circle text-danger" class:d-none={!control.expired} title="{sgettext('$$GLOBAL_CONTROL_EXPIRED_1$$')}"></i>
            {control.name}
          </p>
          <p class="text-secondary" style="white-space: pre-line">
            {control.description}
          </p>
        </div>
      </div>
    {:else}
      <p>{sgettext('$$NONE$$')}</p>
    {/each}
  </div>
</div>